import React, { lazy } from "react";
import ChatSupport from "@/pages/support/chat";
// const ChatSupport = lazy(() => import('@/pages/support/chat'));

export default function ChatSupportPage() {
  return <ChatSupport />;
}
